import { render } from "./EducationMobile.vue?vue&type=template&id=a3ca2fc2&scoped=true"
import script from "./EducationMobile.vue?vue&type=script&lang=js"
export * from "./EducationMobile.vue?vue&type=script&lang=js"

import "./EducationMobile.vue?vue&type=style&index=0&id=a3ca2fc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3ca2fc2"]])

export default __exports__